import { createContext, ReactNode, useEffect, useReducer } from 'react';
// utils
import axios from '../utils/axios';
import * as authAPI from 'api/auth';
import { getMe } from 'api/user';
import { getMainSchool } from 'api/merchant';
import { setSchoolData } from '../redux/slices/merchant';
import { store, useDispatch, useSelector } from '../redux/store';
// import { setStaff } from '../redux/slices/staff';
import { fetchSchoolData } from '../redux/slices/merchant';

import { verifyUrlToken } from 'api/auth';

import { useNavigate } from 'react-router-dom';

import { isValidToken, setSession } from '../utils/jwt';
// @types
import { ActionMap, AuthState, AuthUser, JWTContextType } from '../@types/authentication';

// ----------------------------------------------------------------------

enum Types {
  Initial = 'INITIALIZE',
  Login = 'LOGIN',
  Logout = 'LOGOUT',
  Register = 'REGISTER',
  Getprofile = 'GETPROFILE'
}

type JWTAuthPayload = {
  [Types.Initial]: {
    isAuthenticated: boolean;
    user: AuthUser;
  };
  [Types.Login]: {
    // user: AuthUser;
    token: string;
  };
  [Types.Logout]: undefined;
  [Types.Register]: {
    user: AuthUser;
  };
  [Types.Getprofile]: {
    isAuthenticated: boolean;
    user: AuthUser;
  };
};

export type JWTActions = ActionMap<JWTAuthPayload>[keyof ActionMap<JWTAuthPayload>];

const initialState: AuthState = {
  isAuthenticated: false,
  isSelectedSchool: false,
  isInitialized: false,
  user: null,
  token: null
};

const JWTReducer = (state: AuthState, action: JWTActions): AuthState => {
  switch (action.type) {
    case 'INITIALIZE':
      return {
        ...state,
        isAuthenticated: action.payload.isAuthenticated,
        isInitialized: true,
        user: action.payload.user
      };
    case 'LOGIN':
      return {
        ...state,
        isAuthenticated: true,
        token: action.payload.token
        // user: action.payload.user
      };
    case 'LOGOUT':
      setSession(null);
      return {
        ...state,
        isAuthenticated: false,
        user: null
        // token: null
      };

    case 'REGISTER':
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user
      };

    case 'GETPROFILE':
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user
      };

    default:
      return state;
  }
};

const AuthContext = createContext<JWTContextType | null>(null);

function AuthProvider({ children }: { children: ReactNode }) {
  const [state, dispatch] = useReducer(JWTReducer, initialState);
  const navigate = useNavigate();

  const reduxDispatch = useDispatch();

  useEffect(() => {
    const initialize = async () => {
      try {
        const accessToken = window.localStorage.getItem('access_token');

        if (
          accessToken
          // && isValidToken(accessToken)
        ) {
          // setSession(accessToken);

          const response = await getMe();

          // const response = await axios.get('/api/account/my-account');

          dispatch({
            type: Types.Initial,
            payload: {
              isAuthenticated: true,
              user: response
            }
          });
        } else {
          dispatch({
            type: Types.Initial,
            payload: {
              isAuthenticated: false,
              user: null
            }
          });
        }
      } catch (err) {
        console.error(err);
        dispatch({
          type: Types.Initial,
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
      }
    };

    initialize();
  }, []);

  const login = async (username: string, password: string) => {
    const response = await authAPI.login({
      username,
      password
    });

    console.log(response);

    if (typeof response !== 'string') {
      throw Object.assign(new Error(), { code: response });
    }

    setSession(response);

    const userData = await getMe();

    if (!userData.staff) {
      dispatch({ type: Types.Logout });
      throw Object.assign(new Error(), { code: 'not_allowed_student_login' });
    }
    if (
      userData?.intranet?.resource_status !== 'R' &&
      userData?.intranet?.resource_status !== 'E'
    ) {
      dispatch({ type: Types.Logout });
      throw Object.assign(new Error(), { code: 'no_permission' });
    }

    dispatch({
      type: Types.Login,
      payload: {
        // user,
        token: response
      }
    });

    dispatch({
      type: Types.Initial,
      payload: {
        isAuthenticated: true,
        user: userData
      }
    });
  };

  const register = async (email: string, password: string, firstName: string, lastName: string) => {
    const response = await axios.post('/api/account/register', {
      email,
      password,
      firstName,
      lastName
    });
    const { accessToken, user } = response.data;

    window.localStorage.setItem('accessToken', accessToken);
    dispatch({
      type: Types.Register,
      payload: {
        user
      }
    });
  };

  const logout = async () => {
    const response = await authAPI.logout({});
    setSession(null);
    navigate('/');
    dispatch({ type: Types.Logout });
  };

  const resetPassword = (email: string) => console.log(email);

  const updateProfile = () => {};

  // TokenLOGIN 后台跳转登录
  const tokenLogin = async (objSearch: any) => {
    // store.dispatch(revertAll(null));

    localStorage.removeItem('access_token');
    localStorage.removeItem('uuid');

    // store.dispatch(
    const response = await verifyUrlToken({
      token: objSearch.token,
      lang: objSearch.lang,
      device_id: '',
      access_token: ''
      // callback: async (response: any) => {
      //   const { access_token, device_id } = response;
      //   console.log('access_token', access_token);
      //   const user = await getMe({ access_token, device_id });
      //   // store.dispatch(setStaff(user.staff?.[0]));
      //   // const { merchant_id } = user.staff?.[0];
      //   // await reduxDispatch(
      //   //   fetchSchoolData({ access_token, merchant_id, permit_merchant_id: merchant_id })
      //   // );
      //   // reduxDispatch(setLoginStatus(true));
      //   setSession(access_token);

      //   dispatch({
      //     type: Types.Login,
      //     payload: {
      //       token: access_token
      //     }
      //   });
      //   // window.location.replace(response?.redirect_url);
      // }
    });

    const { access_token, device_id, redirect_url } = response;
    setSession(access_token);
    localStorage.setItem('uuid', device_id);
    const userData = await getMe({ access_token, device_id });

    if (userData?.staff && userData?.staff[0]?.merchant_id) {
      const school = await getMainSchool({ merchant_id: userData.staff[0].merchant_id });

      reduxDispatch(setSchoolData(school));
    }

    dispatch({
      type: Types.Login,
      payload: {
        token: access_token
      }
    });

    if (!userData?.staff) {
      dispatch({ type: Types.Logout });
      return;
    }

    dispatch({
      type: Types.Initial,
      payload: {
        isAuthenticated: true,
        user: userData
      }
    });
  };
  //修改成功后刷新
  const getProfile = async (accessToken: any) => {
    const userData = await getMe();
    dispatch({
      type: Types.Getprofile,
      payload: {
        isAuthenticated: true,
        user: userData
      }
    });
  };

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: 'jwt',
        login,
        logout,
        register,
        resetPassword,
        updateProfile,
        getProfile,
        tokenLogin
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
